import React, { FormEvent, useEffect, useRef, useState } from "react";

import { Button } from "Components/Button";

import { InputCep } from "Components/Form/InputCep";
import {
  getPartnersCombos,
  validateCepPartner,
} from "Requests/SchedulePartners";
import { useQuery, useQueryClient } from "react-query";
import { UnMaskCep } from "Utils/Masks";
import { sanitizeInput } from "Utils/Sanitize";
import { createToast } from "Utils/toastFunc";
import { useScheduleContext } from "Hooks/useScheduleContext";
import { Box } from "styles/globalComponents";
import { ContainerForm, Container } from "../../styles";

export const CheckCep = () => {
  const [zipcode, setZipcode] = useState("");
  const [enableReq, setEnableReq] = useState(false);

  const refCode = useRef("");

  const client = useQueryClient();

  const { advanceToPersonalInfoForm } = useScheduleContext();

  const appointmentTypes = useQuery({
    queryFn: getPartnersCombos,
    queryKey: ["appointments-partners"],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const {
    data: scheduleData,
    isLoading: loadingSchedule,
    isError,
  } = useQuery<{ message: string }>(
    ["checkcep", refCode.current],
    () => validateCepPartner(zipcode.replace("-", "")),
    {
      refetchOnWindowFocus: false,
      enabled: enableReq,
      retry: 1,
      onSuccess: () => moveToNextStep(),
    }
  );

  const onSelectAppointmentId = (appointmentId: number) => {
    advanceToPersonalInfoForm(zipcode, appointmentId);
  };

  const moveToNextStep = () => {
    if (
      appointmentTypes.data?.appointments &&
      appointmentTypes.data?.appointments?.length > 1
    ) {
      return;
    }

    advanceToPersonalInfoForm(zipcode);
  };

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    try {
      if (zipcode?.length < 9) throw new Error("Informe um CEP válido");

      const zip_code = UnMaskCep(zipcode);
      refCode.current = zip_code;
      setEnableReq(true);
    } catch (error: any) {
      createToast("error", error.message);
    }
  };

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (enableReq) setEnableReq(false);
    const sanitized = sanitizeInput(e.target.value) as string;

    setZipcode(sanitized);
  }

  function handleClear() {
    setZipcode("");

    const input = document.querySelector("#cep") as HTMLInputElement;

    if (input) return input.focus();

    return null;
  }

  useEffect(() => {
    return () => client.removeQueries({ queryKey: ["checkcep"] });
  }, []);

  return (
    <Container className="wrapper-form">
      <ContainerForm
        onSubmit={onSubmit}
        className={`search-wrapper ${loadingSchedule ? "-waiting" : ""} `}
      >
        <h2 className="text-center text-centered text-purple section-title">
          Confira se o CEP está coberto por nossa agenda.
        </h2>

        <div className="search-bar">
          <InputCep
            label=""
            id="cep"
            mask="99999-999"
            value={zipcode}
            onChange={handleChange}
            placeholder="Insira o seu CEP"
          />
          <button
            type="submit"
            className="button button-search"
            disabled={loadingSchedule}
          >
            <i className="icon-loupe" />
          </button>
        </div>

        <div className="wrap-text">
          {isError && (
            <p className="message message__14px _error">
              Ainda não temos cobertura para coleta domiciliar neste CEP
            </p>
          )}

          {isError && (
            <>
              <Button onClick={handleClear} type="button">
                Tentar outro cep
              </Button>
            </>
          )}
        </div>

        <div className="schedule-sec">
          {loadingSchedule ? (
            <p className="text-center text-centered text-purple schedule-searching text-md">
              Estamos consultando o cep, aguarde !
            </p>
          ) : null}

          {!loadingSchedule && scheduleData && (
            <p className="text-center text-centered text-purple schedule-searching text-md">
              CEP coberto pela coleta domiciliar
            </p>
          )}

          {scheduleData?.message &&
            appointmentTypes.data &&
            appointmentTypes?.data?.appointments?.length > 1 && (
              <div>
                <p className="text-center text-centered text-purple schedule-searching text-md">
                  Selecione uma das opções de agendamento para continuar
                </p>

                <Box display="flex" justify="center" mt="40">
                  {appointmentTypes.data.appointments.map((appointment) => (
                    <Button
                      onClick={() => onSelectAppointmentId(appointment.id)}
                      fontWeight="600"
                    >
                      {appointment.name}
                    </Button>
                  ))}
                </Box>
              </div>
            )}
        </div>
      </ContainerForm>
    </Container>
  );
};
